import { inject } from "@angular/core";
import { ResolveFn, ActivatedRouteSnapshot } from "@angular/router";
import { catchError, map, of } from "rxjs";
import { Category } from "../../dto/category.model";
import { CategoryService } from "../category.service";

export const categoryResolver: ResolveFn<{ allCategories: Category[], selectedCategory: Category | null }> = (route: ActivatedRouteSnapshot) => {
    const categoryService = inject(CategoryService);

    return categoryService.getAll().pipe(
        map(categories => {
            const categorySlug = route.paramMap.get('categorySlug');
            const firstFilter = route.paramMap.get('firstFilter');

            let selectedCategory: Category | null = null;

            if (firstFilter?.startsWith('c-')) {
                selectedCategory = categories.find(c => c.slug === firstFilter.substring(2)) ?? null;
            } else if (categorySlug) {
                selectedCategory = categories.find(c => c.slug === categorySlug) ?? null;
            }
            return { allCategories: categories, selectedCategory };
        }),
        catchError((error) => {
            console.error('Error fetching listing:', error);
            return of({ allCategories: [], selectedCategory: null });
        })
    );
}